import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";

import { API_BASE_URI } from "../ApiCall";
import { UsageActionTypes } from "./Usage.type";

export function* fetchAllUsage(action: any): any {
  try {
    const response = yield axios.get(
      `${API_BASE_URI}/usage?project_id=${action.payload?.project_id}`
    );
    yield put({
      type: UsageActionTypes.FETCH_ALL_USAGE_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: UsageActionTypes.FETCH_ALL_USAGE_FAILURE,
      payload: error,
    });
  }
}

export function* watcherFetchAllUsage() {
  yield takeLatest(UsageActionTypes.FETCH_ALL_USAGE, fetchAllUsage);
}
